(() => {
  const timers = new WeakMap();

  function initRotators(root) {
    const scope = root || document;
    const sections = scope.matches && scope.matches('[id^="CandelaPassword-"]')
      ? [scope]
      : scope.querySelectorAll('[id^="CandelaPassword-"]');

    sections.forEach((section) => {
      if (timers.has(section)) return;

      const photos = section.querySelectorAll('.candela-password__photo');
      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced || photos.length < 2) return;

      const interval = parseFloat(getComputedStyle(section).getPropertyValue('--rotate-interval')) || 4;
      let index = 0;

      const timer = setInterval(() => {
        photos[index].classList.remove('is-active');
        index = (index + 1) % photos.length;
        photos[index].classList.add('is-active');
      }, interval * 1000);

      timers.set(section, timer);
    });
  }

  function teardown(root) {
    const section = root.querySelector('[id^="CandelaPassword-"]');
    if (section && timers.has(section)) {
      clearInterval(timers.get(section));
      timers.delete(section);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initRotators(document));
  } else {
    initRotators(document);
  }

  document.addEventListener('shopify:section:load', (e) => initRotators(e.target));
  document.addEventListener('shopify:section:unload', (e) => teardown(e.target));
})();
